<template>
  <div>
    <live-camera-grid-view :mode="'history'" />
  </div>
</template>

<script>
// モジュール
import LiveCameraGridView from "./CameraView.vue";

export default {
  components: {
    LiveCameraGridView,
  },
  created() {
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
  },
  beforeDestroy() {
    this.$store.dispatch("updateVerticalNavMenuWidth", "default");
    this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
};
</script>
